const loader = () => {
  const loaderEl = document.querySelector(".spinner-overlay");
  const bodyEl = document.querySelector(".site-container");

  if (loaderEl && !loaderEl.classList.contains("spinner-overlay--hidden")) {
    // bodyEl.classList.add("dis-scroll");

    window.addEventListener("load", () => {
      loaderEl.classList.add("spinner-overlay--hidden");
      bodyEl.classList.remove("dis-scroll");
    });
  }
};

export default loader;
